<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <div class="text-left">
      <h2>Calculs</h2>
    </div>

    <hr>

    <app-alert-messages [contexts]="[alertContextEnum.CalculationDeleted]"></app-alert-messages>

    <div class="row">
      <div class="col-12">

        <div class="card">
          <div class="card-header">
            <div class="row align-items-center">
              <div class="col">

                <!-- Title -->
                <h4 class="card-header-title">
                  Historique
                </h4>

              </div>
              <div class="col-auto">
                <!-- Button -->
                <a aria-expanded="false" aria-haspopup="true" class="btn btn-primary btn-sm" href="#" role="button"
                   routerLink="create">
                  Nouveau calcul
                </a>

              </div>
            </div> <!-- / .row -->
          </div>
          <app-calculation-list></app-calculation-list>
        </div>

      </div>
    </div> <!-- / .row -->

  </div>
</div> <!-- / .row -->